import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PatternImage from "./image/loginPatternImage.svg";
import { LogoImage } from "../../components/commonComponents/StyledComponents/styled";
import WhiteLogo from "../../images/cyreen_logo_white_sRGB _1200.png";
import { useNavigate } from "react-router-dom";
import { DarkGreyButton, LightGreyButton } from "../../components/commonComponents/Buttons/ActionButton";
import { ArrowBack, Backspace, Password } from "@mui/icons-material";
import LockResetIcon from '@mui/icons-material/LockReset';
import { toast } from "react-toastify";
import WhiteInputField from "../../components/commonComponents/TextInputs/WhiteTextInput";
import { forgotUserPassword } from "../../api_calls/userManagement";
import { Stack } from "@mui/material";
import { padding } from "@mui/system";

function Copyright(props) {
  return (
    <>
      <Typography variant="body2" color="#fff" align="center" {...props}>
        {"Copyright © "}
        <Link color="inherit" href="https://cyreen.de/">
          Cyreen
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
      <Typography variant="body2" color="#fff" align="center" {...props} sx={{ mt: 0 }}>
        <Link color="inherit" href="https://cyreen.de/imprint">
          Impressum
        </Link>{" "}
      </Typography>
    </>
  );
}

export default function SignInSide() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = React.useState("");
  const [lastResetedAt, setLastResetedAt] = React.useState("")
  const [cooldown, setCooldown] = React.useState(0);


  const COOLDOWN_RESENT_EMAIL_SECONDS = 15;

  React.useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (cooldown > 0) return;

    forgotUserPassword(userEmail, setLastResetedAt);
    if (userEmail !== "") {
      setCooldown(COOLDOWN_RESENT_EMAIL_SECONDS);
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        backgroundImage: `url(${PatternImage})`,
        backgroundRepeat: "repeat",
        width: "100%",
        height: "100vh",
        backgroundSize: "16px",
        backgroundColor: "rgba(240,75,85,1)",
        overflowX: "auto",
      }}
    >
      <CssBaseline />
      {/* ---------- login section ------------- */}
      <Grid sx={{ backgroundColor: "rgba(240,75,85,1)" }} item xs={12} sm={8} md={5} component={Paper} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* ---------- cyreen logo --------- */}
          <LogoImage src={WhiteLogo} alt="Logo" width="80" />
          <Box height={10} />
          {/* ---------- login screen text --------- */}
          <Typography component="h1" variant="h4" sx={{ color: "#fff", fontWeight: "bold" }}>
            CAP Explorer
          </Typography>
          <Typography component="h1" variant="h5" sx={{ color: "#fff", fontWeight: "bold" }}>
            Reset your password
          </Typography>
          <Box height={10} />
          {/* -------- login inputs ---------- */}
          <Box component="div" sx={{ mt: 1, width: 390 }}>
            {lastResetedAt === "" ? (
              <WhiteInputField
                fieldRequired={true}
                elemId="email"
                labelName="E-Mail"
                fieldName="email"
                defaultVal={userEmail}
                onChangeCall={(e) => {
                  e.preventDefault();
                  setUserEmail(e.target.value);
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  p: 2,
                  borderRadius: 1,
                  border: "1px solid rgba(255, 255, 255, 0.8)",
                }}
              >
                <Typography sx={{ color: "#fff" }}>
                  Your password has been reset successfully. An <br />e-mail with further instructions has been sent to {userEmail}
                </Typography>
              </Box>
            )}

            <Grid container alignItems="center" justifyContent="space-between">
              {/* ------ login button ----- */}
              <Grid item xs>
                <Box height={20} />
                <Stack direction={"row"} spacing={4} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                  <DarkGreyButton
                    label="Back to login"
                    onClick={() => navigate("/")}
                  />
                  <DarkGreyButton
                    label={
                      cooldown > 0
                        ? `${lastResetedAt ? "Resend e-mail" : "Reset password"} (${cooldown}s)`
                        : lastResetedAt
                          ? "Resend e-mail"
                          : "Reset password"
                    } icon={<LockResetIcon />}
                    disabled={cooldown > 0}
                    onClick={handleResetPassword}
                  />
                </Stack>
              </Grid>
            </Grid>
            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Box>
      </Grid>
      {/* -------- pattern on right side of the login section ----------- */}
      {/* <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${PatternImage})`,
          backgroundRepeat: "repeat",
          width: "50%",
          height: "100vh",
          backgroundColor: "rgba(240,75,85,1)",
          backgroundPosition: "0 0",
          backgroundSize: "17px",
          alignSelf: "flex-end",
          marginTop: "-32px",
          paddingTop: "0",
          paddingBottom: "0",
        }}
      /> */}
    </Grid>
  );
}
